var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondaryGraphicVersion2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.6 98.6",
    style: {
      enableBackground: "new 0 0 76.6 98.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st1{fill:#FF5968;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,49.3L0,66.8v-1.2l30.7-16.2L0,33.1v-1.2L33,49.3z M68.8,36.4L0,0v1.2l68.3,36.1c4.5,2.4,7.2,6.9,7.2,12 c0,5-2.8,9.6-7.2,12L0,97.4v1.2l68.8-36.3c4.8-2.5,7.8-7.5,7.8-12.9C76.6,43.9,73.7,39,68.8,36.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryGraphicVersion2);
export default __webpack_public_path__ + "static/media/secondary-graphic-version-2.eeeb5f2e79e901f8236f5422066b8995.svg";
export { ForwardRef as ReactComponent };